var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"bg-white",attrs:{"variant":"default","pill":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v("\n  印刷\n")])}
var staticRenderFns = []

export { render, staticRenderFns }